<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('recruitment.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'recruitments' }">{{ $t('recruitment.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <!-- <div class="row mt-3">
      <div class="col">
        <b-button
          variant="outline-dark"
          @click="$bvModal.show('wugu-warehouse-staff')"
        >法寶流通股工作人員(五股書庫)</b-button>
        <b-modal
          centered
          scrollable
          size="lg"
          id="wugu-warehouse-staff"
          title="誠徵法寶流通股工作人員(五股書庫)"
        >
          <wugu-warehouse-staff></wugu-warehouse-staff>
          <template #modal-footer="{ close }">
            <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
          </template>
        </b-modal>
      </div>
    </div> -->
    <!-- <div class="row mt-3">
      <div class="col">
        <b-button
          variant="outline-dark"
          @click="$bvModal.show('post-production-staff')"
        >攝影剪輯後製正職人員</b-button>
        <b-modal id="post-production-staff" title="誠徵攝影剪輯後製正職人員" centered scrollable size="lg">
          <post-production-staff :course="course"></post-production-staff>
          <template #modal-footer="{ close }">
            <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
          </template>
        </b-modal>
      </div>
    </div> -->
    <div class="row mt-3">
      <div class="col">
        <b-button
          variant="outline-dark"
          @click="$bvModal.show('hwadzan-garden-staff')"
        >華藏教學園區園區工作人員</b-button>
        <b-modal
          centered
          scrollable
          size="lg"
          id="hwadzan-garden-staff"
          title="誠徵華藏教學園區園區工作人員">
          <hwadzan-garden-staff></hwadzan-garden-staff>
          <template #modal-footer="{ close }">
            <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
          </template>
        </b-modal>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <b-button
          variant="outline-dark"
          @click="$bvModal.show('warehouse-staff')"
        >法寶流通工作人員</b-button>
        <b-modal
          centered
          scrollable
          size="lg"
          id="warehouse-staff"
          title="誠徵法寶流通工作人員"
        >
          <warehouse-staff></warehouse-staff>
          <template #modal-footer="{ close }">
            <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
          </template>
        </b-modal>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <b-button
          variant="outline-dark"
          @click="$bvModal.show('library-staff')"
        >三樓講堂工作人員</b-button>
        <b-modal
          centered
          scrollable
          size="lg"
          id="library-staff"
          title="誠徵三樓講堂工作人員">
          <library-staff></library-staff>
          <template #modal-footer="{ close }">
            <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
          </template>
        </b-modal>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <b-button
          variant="outline-dark"
          @click="$bvModal.show('building-renovation-and-water-and-electricity-maintenance-staff')"
        >房舍修繕、水電維護 工作人員</b-button>
        <b-modal
          centered
          scrollable
          size="lg"
          id="building-renovation-and-water-and-electricity-maintenance-staff"
          title="誠徵房舍修繕、水電維護 工作人員">
          <building-renovation-and-water-and-electricity-maintenance-staff>
          </building-renovation-and-water-and-electricity-maintenance-staff>
          <template #modal-footer="{ close }">
            <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import BuildingRenovationAndWaterAndElectricityMaintenanceStaff from '@/views/recruitment/recruitments/BuildingRenovationAndWaterAndElectricityMaintenanceStaff'
import HwadzanGardenStaff from '@/views/recruitment/recruitments/HwadzanGardenStaff'
import LibraryStaff from '@/views/recruitment/recruitments/LibraryStaff'
import PostProductionStaff from '@/views/recruitment/recruitments/PostProductionStaff'
import WarehouseStaff from '@/views/recruitment/recruitments/WarehouseStaff'
import WuguWarehouseStaff from '@/views/recruitment/recruitments/WuguWarehouseStaff'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(ModalPlugin)

export default {
  i18n,
  name: "recruitments",
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    BuildingRenovationAndWaterAndElectricityMaintenanceStaff,
    HwadzanGardenStaff,
    LibraryStaff,
    PostProductionStaff,
    WarehouseStaff,
    WuguWarehouseStaff
  },
  metaInfo() {
    return {
      title: this.$t('recruitment.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>